import { render, staticRenderFns } from "./ktpCourse.vue?vue&type=template&id=f09ed3cc&scoped=true"
import script from "./ktpCourse.vue?vue&type=script&lang=ts"
export * from "./ktpCourse.vue?vue&type=script&lang=ts"
import style0 from "./ktpCourse.vue?vue&type=style&index=0&id=f09ed3cc&prod&scoped=true&lang=scss"
import style1 from "./ktpCourse.vue?vue&type=style&index=1&id=f09ed3cc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f09ed3cc",
  null
  
)

export default component.exports